import * as Sentry from "@sentry/react";

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN || "";
const SENTRY_RELEASE = import.meta.env.VITE_SENTRY_RELEASE || undefined;
const EXPECTED_HTTP_STATUSES = new Set([400, 401, 403, 404, 422]);

export const isSentryEnabled = Boolean(SENTRY_DSN);

export function initSentry() {
  if (!isSentryEnabled) {
    if (import.meta.env.PROD) {
      console.warn("Sentry is disabled: missing VITE_SENTRY_DSN at build time.");
    }
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    release: SENTRY_RELEASE,
    sendDefaultPii: true,
  });
}

export function shouldCaptureError(error: unknown) {
  if (!error || typeof error !== "object" || !("status" in error)) {
    return true;
  }

  const status = Number((error as { status?: unknown }).status);
  if (!Number.isFinite(status)) {
    return true;
  }

  return !EXPECTED_HTTP_STATUSES.has(status);
}

type CaptureExceptionContext = Parameters<typeof Sentry.captureException>[1];

export function captureHandledError(error: unknown, context?: CaptureExceptionContext) {
  if (!isSentryEnabled || !shouldCaptureError(error)) {
    return;
  }

  Sentry.captureException(error, context);
}
